// @hssna/ui-kit/common/Badge — 徽章/标签
// 规格: SPEC §6 / ADR-0012 (Tailwind) / OLD-01 (适老化)
//
// 支持 4 种语义变体 (success/warning/danger/info)
// 用于状态标识 (如健康等级 L1-L5、告警级别、用户角色)

import type { ReactNode } from 'react';

export type BadgeVariant = 'success' | 'warning' | 'danger' | 'info';

export interface BadgeProps {
  /** 变体 */
  readonly variant?: BadgeVariant;
  /** 子节点 */
  readonly children: ReactNode;
  /** 是否为描边样式 (默认填充) */
  readonly outline?: boolean;
  /** 自定义类名 */
  readonly className?: string;
}

const VARIANT_FILLED: Record<BadgeVariant, string> = {
  success: 'bg-health-l1 text-white',
  warning: 'bg-alert-yellow text-white',
  danger: 'bg-alert-red text-white',
  info: 'bg-brand-primary text-white',
};

const VARIANT_OUTLINE: Record<BadgeVariant, string> = {
  success: 'border border-health-l1 text-health-l1 bg-transparent',
  warning: 'border border-alert-yellow text-alert-yellow bg-transparent',
  danger: 'border border-alert-red text-alert-red bg-transparent',
  info: 'border border-brand-primary text-brand-primary bg-transparent',
};

export function Badge({
  variant = 'info',
  children,
  outline = false,
  className = '',
}: BadgeProps) {
  const variantClass = outline ? VARIANT_OUTLINE[variant] : VARIANT_FILLED[variant];
  const classes = [
    'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium',
    'theme-elderly:text-sm theme-elderly:px-3 theme-elderly:py-1',
    variantClass,
    className,
  ].join(' ');

  return <span className={classes}>{children}</span>;
}
